import {
  SET_TTG_GAME_NAMES,
  SET_TTG_GAME_IMAGES,
  SET_TTG_GAME_POLA,
  SET_GAME_ISLOADING,
  SET_GAME_ISERROR
} from '../actionTypes';

const initialState = {
  ttgNames: [],
  ttgImages: [],
  ttgPolas: [],
  nameAndImagesIsLoading: true,
  isError: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TTG_GAME_NAMES:
      return { ...state, ttgNames: action.payload }
    case SET_TTG_GAME_IMAGES:
      return { ...state, ttgImages: action.payload };
    case SET_TTG_GAME_POLA:
      return { ...state, ttgPolas: action.payload };
    case SET_GAME_ISLOADING:
      return { ...state, nameAndImagesIsLoading: action.payload };
    case SET_GAME_ISERROR:
      return { ...state, isError: action.payload };
    default:
      return state;
  };
};

export default reducer;